import React from 'react';
import { FDStack } from '@facet-wealth/design';
import {
  SaveForRetirementStepBody,
} from 'Views/Page/Content/Modal/Layouts/SaveForRetirementStep/SaveForRetirementStepBody';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const SaveForRetirementLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <PXFormModalWrapper buttonLabel={resource.attr('primaryActionLabel')}>
      <FDStack direction="column" spacing={2} alignItems="center" width={'100%'}>
        <SaveForRetirementStepBody />
      </FDStack>
    </PXFormModalWrapper>
  );
};

SaveForRetirementLayout.propTypes = {};

export { SaveForRetirementLayout };
